import React, { useState, createContext } from "react";
import { useNavigate } from "react-router-dom";
import { apiGetCommunityById, apiGetCurrentUser, apiGetUserByEmail } from '../api/api'

export const CommunityContext = createContext()

export const CommunityProvider = (props) => {
    let navigate = useNavigate()
    const [currentPost, setCurrentPost] = useState(null)
    const [ communityData, setCommunityData ] = useState(
        {
            "_id": "",
            "name": "Loading....",
            "admin": "",
            "shortDescription": "",
            "longDescription": "",
            "status": "",
            "rules": "",
            "publicMembers": [],
            "pendingMembers": [],
            "totalMembers": 1,
            "tags": [],
            "createdAt": "",
            "updatedAt": ""
        }
    )
    const [isLoaded, setIsLoaded] = useState(false)
    const [userData, setUserData] = useState(
        {
            "email":"",
            "isAdmin":false
        }
    )
    const [memberData, setMemberData] = useState({});

    const isAdmin = (user, community) => {
        return user.email===community.admin
      }
      
      const isMember = (user, community) => {
        return community.publicMembers.includes(user.email)
      }

    const fetchCommunityData = async (id) => {
        try{
            let res_community = await apiGetCommunityById(id)
            let res_user = await apiGetCurrentUser()
            res_community = res_community.data
            res_user = res_user.data.user
            console.log("community", res_community)
            console.log("user",res_user)
            if (!isAdmin(res_user, res_community) && !isMember(res_user, res_community)){
              navigate(
                "/explore/community-popup",
                {state: {
                  content: res_community,
                  user: res_user
                }}
              )
            }

            setCommunityData(res_community)
            setUserData(
              {
                "email":res_user.email,
                "username":res_user.username,
                "isAdmin": isAdmin(res_user, res_community)
              }
            )
            setIsLoaded(true)
            retrieveAvatars(res_community)
        }
        catch(error){
            console.log(error)
            error.response && alert(error.response.data.detail)
            navigate('/')
          }
    }

    const data = {
        communityData,
        setCommunityData,
        isLoaded,
        setIsLoaded,
        userData,
        setUserData,
        fetchCommunityData,
        currentPost,
        setCurrentPost,
        memberData
      }

    
    const retrieveAvatars = async (community) => {
      const memberAndAdmin = [...community['publicMembers']]
      memberAndAdmin.push(community.admin)
      for(let i = 0; i<memberAndAdmin.length; i++){
        let poster_email = memberAndAdmin[i]
        apiGetUserByEmail(poster_email)
        .then((res)=> {
          let dict = {}
          dict[poster_email] = {
            avatar:res.data.image ? res.data.image : null,
            username: res.data.username
          }
          setMemberData((memberData) => ({...memberData, ...dict}));
        }).catch(error => {
          console.log(error.response)
        })
      }
    }
    

    return (
        <CommunityContext.Provider value={data}>
            {props.children}
        </CommunityContext.Provider>
    )
}
